<template>
    <div id="yagiprimehelp">
        <!--MV-->
        <section class="mv circle">
            <div class="renew2_wrapper">
                <div class="mv-top">
                    <p class="mv-title">待ってるだけで仕事が見つかる！<br>AIが志望動機を一瞬で書いてくれる！</p>
                    <img src="/static/renew3_img/yagiprime_img/mv-logo.png" alt="ヤギプライムヤギッシュ待望の新サービスヤギプライム"
                        class="mv-logo">
                </div>
                <div class="cv-box">
                    <a href="/yagiprime_register" target="_blank" class="cv-btn">ヤギプライムをはじめる</a>
                </div>
            </div>
        </section>

        <!--こんな人におすすめ-->
        <section class="second">
            <ul class="renew2_wrapper second-list">
                <li class="flex second-01">
                    <img src="/static/renew3_img/yagiprime_img/second01.png" alt="仕事探しは面倒" class="second-01left">
                    <div class="second-01right">
                        <p class="second-01righttitle">仕事探しは面倒</p>
                        <p class="second-01righttxt">転職する気持ちはあっても、<br>仕事をいざ探すのは面倒…！</p>
                    </div>
                </li>
                <li class="flex second-01">
                    <img src="/static/renew3_img/yagiprime_img/second02.png" alt="時間がない" class="second-01left">
                    <div class="second-01right">
                        <p class="second-01righttitle">時間がない</p>
                        <p class="second-01righttxt">バイトを始めたいけど、<br>大学生活が忙しくて探す時間取れない…！</p>
                    </div>
                </li>
                <li class="flex second-01">
                    <img src="/static/renew3_img/yagiprime_img/second03.png" alt="文章作成が苦手" class="second-01left">
                    <div class="second-01right">
                        <p class="second-01righttitle">文章作成が苦手</p>
                        <p class="second-01righttxt">新しい仕事に応募したくても、<br>履歴書の自己PRを考えるのは負担…！</p>
                    </div>
                </li>
            </ul>

            <div class="circle">
                <div class="renew2_wrapper">
                    <h3 class="h3">そんなあなたに<br>おすすめ！</h3>
                    <div class="cv-box">
                        <a href="/yagiprime_register" target="_blank" class="cv-btn">ヤギプライムをはじめる</a>
                        <p>¥550（税込）／月。いつでもキャンセルできます。</p>
                    </div>
                    <p class="circle-txt">
                        ヤギプライムは、ヤギッシュの各種サービスを完全無料または一部無料で利用できるほか、面倒な仕事探しが不要になり、志望動機は生成AIで作成することが可能です。時代に合わせて働き方は変化し、ヤギッシュのサービスも常にアップデートしていきます。
                    </p>
                </div>
            </div>
        </section>

        <!--メリット-->
        <section class="third">
            <h2 class="h2">うれしい特典が<br>たくさん！</h2>
            <ul class="renew2_wrapper flex third-01">
                <li class="third-01item">
                    <p class="t-01number">01</p>
                    <h3 class="h3">エージェントからの仕事紹介</h3>
                    <img src="/static/renew3_img/yagiprime_img/third01.png" alt="エージェントからの仕事紹介" class="t-01img">
                    <p>就職活動中の方には1人のエージェントが個別で担当し、手厚い仕事紹介を受けることができます。<br>（中途・新卒どちらもOK）</p>
                </li>
                <li class="third-01item">
                    <p class="t-01number">02</p>
                    <h3 class="h3">おすすめの求人を紹介</h3>
                    <img src="/static/renew3_img/yagiprime_img/third02.png" alt="おすすめの求人を紹介" class="t-01img">
                    <p>バイト探し中の方には1人ひとりにベストなお仕事をご紹介します。あとは選ぶだけで簡単1クリック応募！※採用を保証するものではありません。</p>
                </li>
                <li class="third-01item">
                    <p class="t-01number">03</p>
                    <h3 class="h3">生成AIで志望動機を作成</h3>
                    <img src="/static/renew3_img/yagiprime_img/third03.png" alt="生成AIで志望動機を作成" class="t-01img">
                    <p>ヤギプライム会員の方は、もれなく最新の生成AIを用いたAI志望動機機能を無料で利用することができます！（回数制限は5回／日）</p>
                </li>
                <li class="third-01item">
                    <p class="t-01number">04</p>
                    <h3 class="h3">各種サービスが無料</h3>
                    <img src="/static/renew3_img/yagiprime_img/third04.png" alt="各種サービスが無料" class="t-01img">
                    <p>330円のヤギのメール便とフォント変更機能が無料で使い放題になります。ヤギの宅配便は1回無料で利用可能です。</p>
                </li>
            </ul>
        </section>

        <!--比較表-->
        <section class="renew2_wrapper forth">
            <h2 class="h2">あなたにぴったりの<br>ヤギプライム</h2>
            <table class="forth-table">
                <tr>
                    <td class="f-table01"></td>
                    <td class="f-table02">一般会員</td>
                    <td class="f-table03">ヤギプライム<br>会員</td>
                </tr>
                <tr>
                    <td class="f-table01">ヤギのメール便</td>
                    <td class="f-table02">330円／1回</td>
                    <td class="f-table03">使い放題</td>
                </tr>
                <tr>
                    <td class="f-table01">ヤギの宅配便</td>
                    <td class="f-table02">1,100円／1回</td>
                    <td class="f-table03">1回無料</td>
                </tr>
                <tr>
                    <td class="f-table01">フォント機能</td>
                    <td class="f-table02">なし</td>
                    <td class="f-table03">使い放題</td>
                </tr>
                <tr>
                    <td class="f-table01">AI志望動機作成</td>
                    <td class="f-table02">1回無料</td>
                    <td class="f-table03">5回／日</td>
                </tr>
                <tr>
                    <td class="f-table01">月額</td>
                    <td class="f-table02">無料</td>
                    <td class="f-table03">550円</td>
                </tr>
                <tr>
                    <td class="f-table01">エージェント</td>
                    <td class="f-table02">なし</td>
                    <td class="f-table03">仕事紹介あり</td>
                </tr>
            </table>

            <div class="circle">
                <p class="hukidashi">ズボラのみんな</p>
                <h3 class="h3"><img src="/static/renew3_img/yagiprime_img/deco03.png" alt="早く、速く、簡単に"
                        class="h3-img"><br>ヤギプライムで仕事を</h3>
                <img src="/static/renew3_img/yagiprime_img/deco04.png" alt="ヤギプライムで仕事を" class="forth-c-img">
                <div class="cv-box">
                    <a href="/yagiprime_register" target="_blank" class="cv-btn">ヤギプライムをはじめる</a>
                </div>
            </div>
        </section>

        <!--よくある質問-->
        <section class="renew2_wrapper fifth">
            <h2 class="h2">よくある質問</h2>
            <ul class="faqtop3">
                <li class="faqtop3_item">
                    <p class="question">ヤギプライムってなんですか？</p>
                    <p class="answer">ヤギプライムは、仕事探しをするすべての人を応援する、<br>
                        　 便利機能がいっぱいつまったお得なサブスクリプションサービスです。</p>
                </li>
                <li class="faqtop3_item">
                    <p class="question">ヤギプライムの利用料金を教えてください。</p>
                    <p class="answer">30日ごとに自動更新され、更新すると利用料金550円(税込)がかかります。</p>
                </li>
                <li class="faqtop3_item">
                    <p class="question">利用料金の支払い方法は何がありますか？</p>
                    <p class="answer">クレジットカードがご利用いただけます。</p>
                </li>
                <li class="faqtop3_item">
                    <p class="question">仕事が決まったら、追加料金は発生しますか？</p>
                    <p class="answer">ヤギプライムでは就職や転職、アルバイトで採用が決まっても、追加料金は発生しません。</p>
                </li>
                <li class="faqtop3_item">
                    <p class="question">サービスの規約はどこにありますか？</p>
                    <p class="answer">ヤギプライムの利用規約は<a href="/yagiprimeterms" target="_blank">こちら</a>からご確認ください。</p>
                </li>
            </ul>

            <div class="cv-box">
                <a href="/yagiprime_register" target="_blank" class="cv-btn">ヤギプライムをはじめる</a>
            </div>
        </section>
    </div>

</template>

<style scoped>
/*共通*/
#yagiprimehelp .renew2_wrapper {
    width: 768px;
}

#yagiprimehelp .h2 {
    font-size: 1.2rem;
    color: #004d40;
    text-align: center;
    margin-bottom: 20px;
}

#yagiprimehelp .h3 {
    font-size: 1rem;
    color: #0F9934;
    text-align: center;
    margin-bottom: 20px;
}

#yagiprimehelp .circle {
    position: relative;
    text-align: center;
    padding: 110px 50px;
    overflow: hidden;
}

#yagiprimehelp .circle::before {
    position: absolute;
    content: "";
    background-image: url(/static/renew3_img/yagiprime_img/circle.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    top: 50px;
    left: calc(50% - 280px);
    width: 570px;
    height: 550px;
    z-index: -1;
}

#yagiprimehelp .circle-txt {
    text-align: left;
}

#yagiprimehelp .cv-box {
    text-align: center;
}

#yagiprimehelp .cv-btn {
    width: 100%;
    position: relative;
    display: inline-block;
    background: #e3165c;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
    padding: 15px 0;
    border-radius: 10px;
    -webkit-transition-duration: .4s;
    transition-duration: .4s;
}

#yagiprimehelp .cv-btn::before {
    content: "";
    width: 13px;
    height: 13px;
    border: 0;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 0;
    right: 20px;
    bottom: 0;
    margin: auto;
}

#yagiprimehelp .cv-btn:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    text-decoration: none;
    opacity: 1;
}

/*MV*/
#yagiprimehelp .mv {
    margin-bottom: 50px;
    padding: 50px 0;
    background: #FFFFE8;
}

#yagiprimehelp .mv-title {
    font-size: 1rem;
    font-weight: bold;
    color: #004d40;
}

#yagiprimehelp .mv-top {
    width: 450px;
    max-width: 100%;
    margin: 0 auto 30px;
}

/*こんな人におすすめ*/
#yagiprimehelp .second {
    margin-bottom: 50px;
    overflow: hidden;
}

#yagiprimehelp .second-list {
    width: 450px;
    max-width: 100%;
    margin-bottom: 50px;
}

#yagiprimehelp .second-01 {
    align-items: center;
    margin-bottom: 10px;
}

#yagiprimehelp .second-01left {
    width: 135px;
    height: 130px;
    margin-right: 10px;
    object-fit: cover;
}

#yagiprimehelp .second-01righttitle {
    position: relative;
    font-size: 1.4rem;
    font-weight: bold;
}

#yagiprimehelp .second-01righttitle::before {
    position: absolute;
    content: "";
    background-image: url(/static/renew3_img/yagiprime_img//deco01.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 50px;
    height: 15px;
    top: -15px;
    left: 0;
}

#yagiprimehelp .second .cv-box {
    margin-bottom: 20px;
}

#yagiprimehelp .second .h3 {
    position: relative;
    margin-bottom: 100px;
}

#yagiprimehelp .second .h3::after {
    position: absolute;
    content: "";
    background-image: url(/static/renew3_img/yagiprime_img/deco02.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 350px;
    height: 130px;
    top: 50px;
    left: calc(50% - 155px);
    z-index: 2;
}

/*メリット*/
#yagiprimehelp .third {
    background: #FFFFE8;
    padding: 50px 0 40px;
    margin-bottom: 50px;
}

#yagiprimehelp .third-01 {
    flex-wrap: wrap;
    justify-content: space-between;
}

#yagiprimehelp .third-01item {
    padding: 4ch 20px;
    border-radius: 10px;
    border: 2px dotted #0F9934;
    width: 100%;
    margin-bottom: 20px;
}

#yagiprimehelp .t-01number {
    text-align: center;
    color: #0F9934;
    font-size: 1.2rem;
    font-weight: bold;
    opacity: 0.5;
}

#yagiprimehelp .t-01img {
    display: block;
    text-align: center;
    height: 150px;
    width: auto;
    margin: 0 auto 20px;
}

/*比較表*/
#yagiprimehelp .forth {
    margin-bottom: 50px;
}

#yagiprimehelp .forth-table {
    width: 100%;
    text-align: center;
    margin-bottom: 50px;
}

#yagiprimehelp .forth-table td {
    padding: 10px 0;
    border: solid 1px #EEF5E8;
    vertical-align: middle;
}

#yagiprimehelp .f-table01 {
    font-weight: bold;
}

#yagiprimehelp .f-table03 {
    font-weight: bold;
    font-size: 1rem;
    background: #FFFFE8;
}

#yagiprimehelp .hukidashi {
    position: relative;
    display: inline-block;
    background: #0F9934;
    color: #fff;
    font-weight: bold;
    padding: 5px 20px;
    margin-bottom: 30px;
    border-radius: 50px;
}

#yagiprimehelp .hukidashi::after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 30px solid #0F9934;
    bottom: -10px;
    right: calc(50% - 20px);
    z-index: -1;
}

#yagiprimehelp .forth .h3-img {
    height: auto;
    width: 260px;
    margin-bottom: 8px;
}

#yagiprimehelp .forth-c-img {
    height: 200px;
    width: auto;
    object-fit: cover;
    margin-bottom: 30px;
}

/*よくある質問*/
#yagiprimehelp .fifth {
    margin-bottom: 50px;
}

#yagiprimehelp .faqtop3_item {
    margin-bottom: 20px;
}

#yagiprimehelp .question {
    position: relative;
    font-weight: 700;
    color: #004d40;
    padding: 0 0 10px 30px;
}

#yagiprimehelp .question::before {
    position: absolute;
    content: "Q";
    color: #0f9934;
    font-size: 1.6rem;
    left: 3px;
    top: -10px;
    opacity: .5;
}

#yagiprimehelp .answer {
    padding: 30px;
    background: #ffffe8;
    border-radius: 10px;
}

/*PCサイズ*/
@media screen and (min-width: 641px) {
    #yagiprimehelp .cv-btn {
        width: 300px;
    }

    #yagiprimehelp .third-01item {
        width: calc(100% / 2 - 10px);
    }
}
</style>
<script>
export default {
    data: function () {
        return {
            question1: false,
            question2: false,
            question3: false,
            question4: false,
            question5: false,
            question6: false,
            question7: false,
            question8: false
        }
    },
    computed: {},
    methods: {
        viewAnswer: function (name) {
            console.error(name)
            this.question1 = true
        }
    },
    watch: {},
    created: function () {

        const app = this

        app.$cookies.config(60 * 60 * 24, '')
        var route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
        app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#prime_lp', null, null, 'yagish.jp')
        app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#prime_lp', null, null, 'localhost')

    },
    mounted: function () { }
}
</script>
